import api from "../../api"
import {

    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAIL,
    CLEAR_ERRORS,


    VERIFY_TIME_REQUEST,
    VERIFY_TIME_SUCCESS,
    VERIFY_TIME_FAIL,


    RESEND_EMAIL_REQUEST,
    RESEND_EMAIL_SUCCESS,
    RESEND_EMAIL_FAIL,

    VERIFY_EMAIL_REQUEST,
    VERIFY_EMAIL_SUCCESS,
    VERIFY_EMAIL_FAIL,


    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAIL,

    LOGOUT_SUCCESS,
    LOGOUT_FAIL,

    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,

    LOAD_USER_REQUEST,
    LOAD_USER_SUCCESS,
    LOAD_USER_FAIL,

    FORGET_PASSWORD_REQUEST,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAIL,

    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,

    ALL_USERS_REQUEST,
    ALL_USERS_SUCCESS,
    ALL_USERS_FAIL,



    UPDATE_ROLE_REQUEST,
    UPDATE_ROLE_SUCCESS,
    UPDATE_ROLE_FAIL,

    UPDATE_USER_RESET,


    UPDATE_AVATAR_REQUEST,
    UPDATE_AVATAR_SUCCESS,
    UPDATE_AVATAR_FAIL,

    CLEAR_MESSAGES,

} from "../constants/userConstants"


export const registerAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: REGISTER_USER_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/register`, userData, config)
        dispatch({
            type: REGISTER_USER_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: REGISTER_USER_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}












export const verifyEmailTimeAction = (email) => async (dispatch) => {
    try {
        dispatch({ type: VERIFY_TIME_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/email-expiry-time/`, email, config)
        dispatch({
            type: VERIFY_TIME_SUCCESS,
            payload: data.expiryTime,
        })
    } catch (error) {
        dispatch({
            type: VERIFY_TIME_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const resendEmailAction = (email) => async (dispatch) => {
    try {
        dispatch({ type: RESEND_EMAIL_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/resend-email/`, email, config)
        dispatch({
            type: RESEND_EMAIL_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: RESEND_EMAIL_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const verifyEmailAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: VERIFY_EMAIL_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/verify-email/`, userData, config)
        dispatch({
            type: VERIFY_EMAIL_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: VERIFY_EMAIL_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const updateUserAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_USER_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.put(`/api/v1/update-user/`, userData, config)
        dispatch({
            type: UPDATE_USER_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: UPDATE_USER_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const LogoutUserAction = () => async (dispatch) => {
    try {

        await api.get(`/api/v1/logout`)
        dispatch({ type: LOGOUT_SUCCESS })
    } catch (error) {
        dispatch({
            type: LOGOUT_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const loginAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: LOGIN_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

    console.log('API URL:', process.env.REACT_APP_API_URL);


        const { data } = await api.post(`/api/v1/login/`, userData, config)
        dispatch({
            type: LOGIN_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: LOGIN_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const loadUserAction = () => async (dispatch) => {
    try {
        dispatch({ type: LOAD_USER_REQUEST })

        const { data } = await api.get(`/api/v1/me`)
        dispatch({
            type: LOAD_USER_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: LOAD_USER_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const forgotPasswordAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: FORGET_PASSWORD_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/forgot-password/`, userData, config)
        dispatch({
            type: FORGET_PASSWORD_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: FORGET_PASSWORD_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const resetPasswordAction = (userData, token) => async (dispatch) => {
    try {
        dispatch({ type: RESET_PASSWORD_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.put(`/api/v1/reset-password?token=${token}`, userData, config)
        dispatch({
            type: RESET_PASSWORD_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: RESET_PASSWORD_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}





export const allUsersAction = () => async (dispatch) => {
    try {
        dispatch({ type: ALL_USERS_REQUEST })

        const { data } = await api.get(`/api/v1/get-all-users`)
        dispatch({
            type: ALL_USERS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALL_USERS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const filterUsersAction = () => async (dispatch) => {
    try {
        dispatch({ type: ALL_USERS_REQUEST })

        const { data } = await api.get(`/api/v1/filter-users`)
        dispatch({
            type: ALL_USERS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALL_USERS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}




export const UpdateRoleAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_ROLE_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }


        const { data } = await api.put(`/api/v1/update-role`, userData, config)
        dispatch({
            type: UPDATE_ROLE_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: UPDATE_ROLE_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}



export const updateAvatarAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_AVATAR_REQUEST })
        const config = { headers: { "Content-Type": "multipart/form-data" } }

        const { data } = await api.put(`/api/v1/update-avatar`, userData, config)
        dispatch({
            type: UPDATE_AVATAR_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: UPDATE_AVATAR_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}









export const clearMessage = () => async (dispatch) => {
    dispatch({ type: CLEAR_MESSAGES })
}

export const clearErrors = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS })
}

export const updateUserResetAction = () => async (dispatch) => {
    dispatch({ type: UPDATE_USER_RESET })
}